import { render, staticRenderFns } from "./ot-claims-table.vue?vue&type=template&id=5acd0756&scoped=true&"
import script from "./ot-claims-table.vue?vue&type=script&lang=ts&"
export * from "./ot-claims-table.vue?vue&type=script&lang=ts&"
import style0 from "./ot-claims-table.vue?vue&type=style&index=0&id=5acd0756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acd0756",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VMenu,VTooltip})
